 
<template>
  <div id="maple-layout">
    <!--电量报警-->
    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="monit-box"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
        v-if="item.ICUEle <= ConfigList.EquipmentBattery && item.ICUEle !=0"
      >
        <h3 @touchstart="down">
          <img src="../assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="../assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="../assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="../assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="../assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==4" :class="{yellow:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else :class="{green:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="../assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_search_alarmstrong_prepare.png"
              alt
              v-else-if="item.AlarmStatus==4"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="../assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="../assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="../assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <img
              src="../assets/images/icon_height_yellow_64.png"
              alt
              v-else-if="item.AlarmStatus==4"
            />
            <img src="../assets/images/icon_height_green_64.png" alt v-else />
            <font
              v-if="item.isOnLine"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==4"
              :class="{yellow:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else
              :class="{green:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <div class="monit-centent">
          <p>互救器电量过低</p>
          <button @click="closeCall">我知道了</button>
        </div>
      </div>
      <div class="monit-mask" v-if="item.ICUEle <= ConfigList.EquipmentBattery && item.ICUEle !=0 "></div>
    </template>
    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="monit-box"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
        v-if="item.Location && item.Location.TrackElec <= ConfigList.EquipmentBattery"
      >
        <h3 @touchstart="down">
          <img src="../assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="../assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="../assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="../assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="../assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==4" :class="{yellow:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else :class="{green:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="../assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_search_alarmstrong_prepare.png"
              alt
              v-else-if="item.AlarmStatus==4"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="../assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="../assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="../assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <img
              src="../assets/images/icon_height_yellow_64.png"
              alt
              v-else-if="item.AlarmStatus==4"
            />
            <img src="../assets/images/icon_height_green_64.png" alt v-else />
            <font
              v-if="item.isOnLine"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==4"
              :class="{yellow:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else
              :class="{green:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <div class="monit-centent">
          <p>定位器电量过低</p>
          <button @click="closeCall">我知道了</button>
        </div>
      </div>
      <div
        class="monit-mask"
        v-if="item.Location && item.Location.TrackElec <= ConfigList.EquipmentBattery"
      ></div>
    </template>

    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="monit-box"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
        v-if="item.Device==1 && item.DeviceEle <= ConfigList.EquipmentBattery"
      >
        <h3 @touchstart="down">
          <img src="../assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="../assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="../assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="../assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="../assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==4" :class="{yellow:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else :class="{green:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="../assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_search_alarmstrong_prepare.png"
              alt
              v-else-if="item.AlarmStatus==4"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="../assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="../assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="../assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <img
              src="../assets/images/icon_height_yellow_64.png"
              alt
              v-else-if="item.AlarmStatus==4"
            />
            <img src="../assets/images/icon_height_green_64.png" alt v-else />
            <font
              v-if="item.isOnLine"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==4"
              :class="{yellow:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else
              :class="{green:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <div class="monit-centent">
          <p>手环电量过低</p>
          <button @click="closeCall">我知道了</button>
        </div>
      </div>
      <div
        class="monit-mask"
        v-if="item.Device==1 && item.DeviceEle <= ConfigList.EquipmentBattery"
      ></div>
    </template>
    <!--队员心率报警-->
    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="monit-box"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
        v-if="(item.Device == 1 || item.Device == 2) && (item.DeviceHeartRate > ConfigList.TeamHeartRateMax || item.DeviceHeartRate < ConfigList.TeamHeartRateMin)"
      >
        <h3 @touchstart="down">
          <img src="../assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="../assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="../assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="../assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="../assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==4" :class="{yellow:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else :class="{green:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="../assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_search_alarmstrong_prepare.png"
              alt
              v-else-if="item.AlarmStatus==4"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="../assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="../assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="../assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <img
              src="../assets/images/icon_height_yellow_64.png"
              alt
              v-else-if="item.AlarmStatus==4"
            />
            <img src="../assets/images/icon_height_green_64.png" alt v-else />
            <font
              v-if="item.isOnLine"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==4"
              :class="{yellow:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else
              :class="{green:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <div class="monit-centent">
          <p
            v-if="(item.DeviceHeartRate==null?0:item.DeviceHeartRate) > ConfigList.TeamHeartRateMax"
          >队员心率过高</p>
          <p
            v-else-if="(item.DeviceHeartRate==null?200:item.DeviceHeartRate) < ConfigList.TeamHeartRateMin"
          >队员心率过低</p>
          <button @click="closeCall">我知道了</button>
        </div>
      </div>
      <!-- && !timeLeave(item.Phone.Loop)-->
      <div
        class="monit-mask"
        v-if="(item.Device == 1 || item.Device == 2) && (item.DeviceHeartRate > ConfigList.TeamHeartRateMax || item.DeviceHeartRate < ConfigList.TeamHeartRateMin)"
      ></div>
    </template>
    <!--环境温度报警-->
    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="monit-box"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
        v-if="item.Temperature > ConfigList.AmbienTemperature"
      >
        <h3 @touchstart="down">
          <img src="../assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="../assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="../assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="../assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="../assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==4" :class="{yellow:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else :class="{green:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="../assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_search_alarmstrong_prepare.png"
              alt
              v-else-if="item.AlarmStatus==4"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="../assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="../assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="../assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <img
              src="../assets/images/icon_height_yellow_64.png"
              alt
              v-else-if="item.AlarmStatus==4"
            />
            <img src="../assets/images/icon_height_green_64.png" alt v-else />
            <font
              v-if="item.isOnLine"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==4"
              :class="{yellow:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else
              :class="{green:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <div class="monit-centent">
          <p>环境温度过高</p>
          <button @click="closeCall">我知道了</button>
        </div>
      </div>
      <div class="monit-mask" v-if="item.Temperature > ConfigList.AmbienTemperature"></div>
    </template>

    <!--出发时长报警-->
    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="monit-box"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
        v-if="item.DepartDuration_AI!=null && item.DepartDuration_AI!=undefined && item.DepartDuration_AI/60 > ConfigList.TimeOfDeparture"
      >
        <h3 @touchstart="down">
          <img src="../assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="../assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="../assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="../assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="../assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==4" :class="{yellow:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else :class="{green:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="../assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_search_alarmstrong_prepare.png"
              alt
              v-else-if="item.AlarmStatus==4"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="../assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="../assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="../assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <img
              src="../assets/images/icon_height_yellow_64.png"
              alt
              v-else-if="item.AlarmStatus==4"
            />
            <img src="../assets/images/icon_height_green_64.png" alt v-else />
            <font
              v-if="item.isOnLine"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==4"
              :class="{yellow:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else
              :class="{green:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <div class="monit-centent">
          <p>出发时长过长</p>
          <button @click="closeCall">我知道了</button>
        </div>
      </div>
      <div class="monit-mask" v-if="item.DepartDuration_AI!=null && item.DepartDuration_AI!=undefined && item.DepartDuration_AI/60 > ConfigList.TimeOfDeparture"></div>
    </template>

    <!--空呼剩余时长报警-->
    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="monit-box"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
        v-if="item.GASRemainingTime && item.GASRemainingTime < ConfigList.CallRemainingTime"
      >
        <h3 @touchstart="down">
          <img src="../assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="../assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="../assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="../assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="../assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==4" :class="{yellow:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else :class="{green:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="../assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_search_alarmstrong_prepare.png"
              alt
              v-else-if="item.AlarmStatus==4"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="../assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="../assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="../assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <img
              src="../assets/images/icon_height_yellow_64.png"
              alt
              v-else-if="item.AlarmStatus==4"
            />
            <img src="../assets/images/icon_height_green_64.png" alt v-else />
            <font
              v-if="item.isOnLine"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==4"
              :class="{yellow:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else
              :class="{green:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <div class="monit-centent">
          <p>空呼剩余时长过短</p>
          <button @click="closeCall">我知道了</button>
        </div>
      </div>
      <div
        class="monit-mask"
        v-if="item.GASRemainingTime && item.GASRemainingTime < ConfigList.CallRemainingTime"
      ></div>
    </template>

    <!--空呼压力报警-->
    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="monit-box"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
        v-if="item.GASPressure && item.GASPressure <= 10"
      >
        <h3 @touchstart="down">
          <img src="../assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="../assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="../assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="../assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="../assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==4" :class="{yellow:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else :class="{green:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="@/assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="@/assets/images/icon_search_alarmstrong_prepare.png"
              alt
              v-else-if="item.AlarmStatus==4"
              style="float:right;"
            />
            <img
              src="@/assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="@/assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="@/assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="@/assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <img
              src="@/assets/images/icon_height_yellow_64.png"
              alt
              v-else-if="item.AlarmStatus==4"
            />
            <img src="@/assets/images/icon_height_green_64.png" alt v-else />
            <font
              v-if="item.isOnLine"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==4"
              :class="{yellow:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else
              :class="{green:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <div class="monit-centent">
          <p>空呼压力过小</p>
          <button @click="closeCall">我知道了</button>
        </div>
      </div>
      <div class="monit-mask" v-if="item.GASPressure && item.GASPressure <= 10 "></div>
    </template>

    <!--队员体温报警-->
    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="monit-box"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
        v-if="item.Device == 2 && item.DeviceTemperature < ConfigList.BodySurfaceTemperatureMin"
      >
        <h3 @touchstart="down">
          <img src="@/assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="@/assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="@/assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="@/assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="@/assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==4" :class="{yellow:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else :class="{green:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="../assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_search_alarmstrong_prepare.png"
              alt
              v-else-if="item.AlarmStatus==4"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="../assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="../assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="../assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <img
              src="../assets/images/icon_height_yellow_64.png"
              alt
              v-else-if="item.AlarmStatus==4"
            />
            <img src="../assets/images/icon_height_green_64.png" alt v-else />
            <font
              v-if="item.isOnLine"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==4"
              :class="{yellow:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else
              :class="{green:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <div class="monit-centent">
          <p>队员体温过低</p>
          <button @click="closeCall">我知道了</button>
        </div>
      </div>
      <div
        class="monit-mask"
        v-if="item.Device == 2 && item.DeviceTemperature < ConfigList.BodySurfaceTemperatureMin"
      ></div>
    </template>

    <!--血氧浓度报警-->
    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="monit-box"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
        v-if="item.Device == 2 && item.DeviceBloodOxygen < ConfigList.BloodOxygenMin"
      >
        <h3 @touchstart="down">
          <img src="@/assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="@/assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="../assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="../assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="../assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==4" :class="{yellow:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else :class="{green:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="../assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_search_alarmstrong_prepare.png"
              alt
              v-else-if="item.AlarmStatus==4"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="../assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="../assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="../assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <img
              src="../assets/images/icon_height_yellow_64.png"
              alt
              v-else-if="item.AlarmStatus==4"
            />
            <img src="../assets/images/icon_height_green_64.png" alt v-else />
            <font
              v-if="item.isOnLine"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==4"
              :class="{yellow:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else
              :class="{green:isColor}"
            >{{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <div class="monit-centent">
          <p>血氧浓度过低</p>
          <button @click="closeCall">我知道了</button>
        </div>
      </div>
      <div
        class="monit-mask"
        v-if="item.Device == 2 && item.DeviceBloodOxygen < ConfigList.BloodOxygenMin"
      ></div>
    </template>

    <!--sos报警-->
    <template v-for="(item,index) in TeamMemberLists">
      <div
        class="sos-box"
        v-if="(item.AlarmStatus == 3 || item.AlarmStatus == 6)"
        :style="{marginTop:-153+index*5+'px',marginLeft:-210+index*5+'px'}"
      >
        <h3 @touchstart="down">
          <img src="../assets/images/icon_search_helmet_offline.png" alt v-if="item.isOnLine" />
          <img
            src="../assets/images/icon_search_helmet_alarmstrong.png"
            alt
            v-else-if="item.AlarmStatus==6"
          />
          <img
            src="../assets/images/icon_search_helmet_alarmpre.png"
            alt
            v-else-if="item.AlarmStatus==4"
          />
          <img
            src="../assets/images/home_icon_recco_manualalert.png"
            alt
            v-else-if="item.AlarmStatus==3"
          />
          <img src="../assets/images/icon_search_helmet_normal.png" alt v-else />
          <span v-if="item.isOnLine" :class="{'off-lines':isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <span v-else-if="item.AlarmStatus==6 ||item.AlarmStatus==3" :class="{red:isColor}">
            {{item.GroupName}}
            <br />
            {{item.Name}}
          </span>
          <div>
            <img
              src="../assets/images/icon_alarm_notonline_64.png"
              alt
              v-if="item.isOnLine"
              style="float:right;"
            />
            <img
              src="../assets/images/icon_alarmstrong_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              style="float:right;"
            />
            <img src="../assets/images/icon_alarm_normal_64.png" alt v-else style="float:right;" />
            <br />
            <img src="../assets/images/icon_height_64.png" alt v-if="item.isOnLine" />
            <img
              src="../assets/images/icon_alarmstrong_height_64.png"
              alt
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
            />
            <font
              v-if="item.isOnLine"
              :class="{'off-lines':isColor}"
            >{{item.RelativelyHigh == undefined || item.RelativelyHigh == false || item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
            <font
              v-else-if="item.AlarmStatus==6 || item.AlarmStatus==3"
              :class="{red:isColor}"
            >{{item.RelativelyHigh == undefined || item.RelativelyHigh == false || item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}}m</font>
          </div>
        </h3>
        <p>SOS</p>
        <div>
          <button @click="cancalSos($event,item.AlarmStatus)" :index="item.SN">取消</button>
          <button
            @click="okSos($event,item.SN,item.GroupName,index,item.AlarmStatus,item.RelativelyHigh,item.Altitude)"
          >营救</button>
        </div>
      </div>
      <div class="mask" v-if="(item.AlarmStatus == 3 || item.AlarmStatus == 6)"></div>
    </template>

    <!--  -->
    <template>
      <div
        class="monit-box"
        style="width: 490px;margin-left: -245px;height:300px;margin-top: -150px"
        v-if="JSON.stringify(rescueTeamMemberList) != '{}'"
      >
        <h3
          @touchstart="down"
          style="background: #fff;font-size: 28px;text-align: center;line-height: 80px;"
        >提示</h3>
        <div class="monit-centent">
          <p style="font-size: 21px; color:#333;margin: 37px 0 57px;">
            <font
              style="color:#3FDB23;"
            >{{getManualGroup(rescueTeamMemberList.SGroupName,rescueTeamMemberList.SN)}}</font>
            正在营救 {{getManualGroup(rescueTeamMemberList.RGroupName,rescueTeamMemberList.Rsn)}}
          </p>
          <button @click="closeManual" style="background:#3FDB23; ">我知道了</button>
        </div>
      </div>
      <div
        class="monit-mask"
        v-if="JSON.stringify(rescueTeamMemberList) != '{}' &&　$route.name !='rescue'"
      ></div>
    </template>

    <template>
      <div
        class="monit-box"
        style="width: 490px;margin-left: -245px;height:300px;margin-top: -150px"
        v-if="JSON.stringify(rescueErrMsg) != '{}'"
      >
        <h3
          @touchstart="down"
          style="background: #fff;font-size: 28px;text-align: center;line-height: 80px;"
        >提示</h3>
        <div class="monit-centent">
          <p style="font-size: 21px; color:#333;margin: 37px 0 57px;">
            <font style="color:#3FDB23;">{{rescueErrMsg.GroupName+' '+rescueErrMsg.Name}}</font>
            {{rescueErrMsg.msg}}
          </p>
          <button @click="closeManual" style="background:#3FDB23; ">我知道了</button>
        </div>
      </div>
      <div class="monit-mask" v-if="JSON.stringify(rescueErrMsg) != '{}'"></div>
    </template>

    <a-layout class="maple-layout">
      <a-layout-sider class="maple-sider" :width="menuWidth">
        <div class="maple-menu-logo" align="center">
          <img src="@/assets/images/about_logo.png" v-if="ScreenWidth>1000" />
          <img src="@/assets/logo.png" v-else />
        </div>
        <div class="maple-menu-item maple-menu-item-xs" :class="{ 'active': pathName == 'home'}">
          <a @click="routers('home')">
            <img src="@/assets/images/nav_icon_home_normal.png" class="src-home" />
          </a>
        </div>
        <div
          class="maple-menu-item maple-menu-item-xs"
          :class="{ 'active': pathName == 'build'||pathName == 'buildMake'||pathName == 'buildList'||pathName == 'builds'}"
        >
          <a id="buildPage" @click="routers('build')">
            <img src="@/assets/images/nav_icon_modeling_normal.png" class="src-modeling" />
          </a>
        </div>
        <div
          class="maple-menu-item maple-menu-item-xs"
          :class="{ 'active': pathName == 'teams' || pathName == 'allteam'}"
        >
          <a @click="routers('team')">
            <img src="@/assets/images/nav_icon_team_normal.png" class="src-team" />
          </a>
        </div>
        <div
          class="maple-menu-item maple-menu-item-xs"
          :class="{ 'active': pathName == 'DataAnalysis'}"
        >
          <a @click="routers('DataAnalysis')">
            <img src="@/assets/images/tab_search_data.png" class="src-search" />
          </a>
        </div>
        <div class="maple-menu-item maple-menu-item-xs" :class="{ 'active': pathName == 'RVideo'}">
          <a @click="RSPlayer()">
            <img src="@/assets/images/nav_video.png" class="src-RVideo" />
          </a>
        </div>
           <div class="maple-menu-item maple-menu-item-xs" v-if="ISElectron">
          <a @click="RSUAVVideo()">
            <img src="@/assets/nav_icon_uav_selected.png" />
          </a>
        </div>
        <div class="maple-menu-item maple-menu-item-xs">
          <a @click="allRetreat()">
            <img src="@/assets/images/icon_allretreat_selected.png" v-if="retreatIcon" />
            <img src="@/assets/images/icon_allretreat.png" v-else />
          </a>
        </div>
        <div
          class="maple-menu-item maple-menu-item-xs"
          :class="{ 'active': pathName == 'about' || pathName == 'setup-about' || pathName == 'setup' || pathName == 'UserManage'}"
        >
          <a @click="routers('about')">
            <img src="@/assets/images/nav_icon_setup_normal.png" class="src-setup" />
          </a>
        </div>
      </a-layout-sider>
      <a-layout>
        <a-layout-content  class="maple-content">
          <router-view v-if="isReload" :key="$route.fullPath" />
        </a-layout-content>
      </a-layout>
    </a-layout>
    <!-- <div class="maple-menu">
      <div class="maple-menu-logo" align="center">
        <img src="@/assets/images/about_logo.png" v-if="ScreenWidth>1000" />
        <img src="@/assets/logo.png" v-else />
      </div>
      <div class="maple-menu-item maple-menu-item-xs" :class="{ 'active': pathName == 'home'}">
        <a @click="routers('home')">
          <img src="@/assets/images/nav_icon_home_normal.png" class="src-home" />
        </a>
      </div>
      <div
        class="maple-menu-item maple-menu-item-xs"
        :class="{ 'active': pathName == 'build'||pathName == 'buildMake'||pathName == 'buildList'||pathName == 'builds'}"
      >
        <a id="buildPage" @click="routers('build')">
          <img src="@/assets/images/nav_icon_modeling_normal.png" class="src-modeling" />
        </a>
      </div>
      <div
        class="maple-menu-item maple-menu-item-xs"
        :class="{ 'active': pathName == 'teams' || pathName == 'allteam'}"
      >
        <a @click="routers('team')">
          <img src="@/assets/images/nav_icon_team_normal.png" class="src-team" />
        </a>
      </div>
      <div
        class="maple-menu-item maple-menu-item-xs"
        :class="{ 'active': pathName == 'DataAnalysis'}"
      >
        <a @click="routers('DataAnalysis')">
          <img src="@/assets/images/tab_search_data.png" class="src-search" />
        </a>
      </div>
      <div class="maple-menu-item maple-menu-item-xs" :class="{ 'active': pathName == 'RVideo'}">
        <a @click="RSPlayer()">
          <img src="@/assets/images/nav_video.png" class="src-RVideo" />
        </a>
      </div>
      <div class="maple-menu-item maple-menu-item-xs">
        <a @click="allRetreat()">
          <img src="@/assets/images/icon_allretreat_selected.png" v-if="retreatIcon" />
          <img src="@/assets/images/icon_allretreat.png" v-else />
        </a>
      </div>
      <div
        class="maple-menu-item maple-menu-item-xs"
        :class="{ 'active': pathName == 'setup' || pathName == 'setup-about'}"
      >
        <a @click="routers('setup')">
          <img src="@/assets/images/nav_icon_setup_normal.png" class="src-setup" />
        </a>
      </div>
    </div>
    <div class="maple-content">
      <router-view v-if="isReload" :key="$route.fullPath" />
    </div>-->
    <retreat :show="isRetreat" :msg="retreatMsg" @ok="okRetreat" @cancal="cancalRetreat"></retreat>
  </div>
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import * as signalR from "@microsoft/signalr";
import HomeService from "@/api/HomeService";
import Retreat from "@/components/retreat";
import SetupService from "@/api/SetupService";
import LoginService from "@/api/LoginService";
import AllTeamService from "@/api/AllTeamService";
import BuildService from "@/api/BuildService";
import router from "@/router";
import axios from "axios"


export default {
  name: "RouteView",
  components: { Retreat },
  provide() {
    // 利用vue的provide方法
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      pathName: this.$route.path,
      Websock: null,
      isReload: true,
      isSos: new Array(50).fill(true),
      sosMsg: new Array(50).fill(false),
      isRetreat: false,
      retreatMsg: "",
      setTeamMemberList3: [],
      isObj: {},
      monitBox: false,
      isColor: true,
      left: 0,
      top: 0,
      X: 0,
      Y: 0,
      elen: null,
      showIndex: 3,
      retreatIcon: false,
      groupName: [],
      rescueTeamMemberList: {},
      msg: "",
      rescueErrMsg: {},
      ScreenWidth: document.body.clientWidth, //屏宽
      menuWidth:100,
      setIntervalGetTroopsTeamMemberStatus:null,
      UDTime:[], 
      locationTime:[],
      query:window.location.search.substring(1),
      connection:null,
      ISElectron:false,
      workState:{},
      workStateInterval:{},
    };
  },
  created() { 
    let url = "/msg"; 
 
    let type2 = this.getQueryVariable('type')                                     
    if(type2!=1){ 
      this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url, {
        accessTokenFactory() { 
          return sessionStorage.getItem("Authorization"); 
        }
      })
      .build(); 
      this.connection.keepAliveIntervalInMilliseconds = 12e4;
      this.connection.serverTimeoutInMilliseconds = 24e4;
      this.connection.start().catch(err =>{
        setTimeout(()=>{
          this.Reconnect()
        },4000)
      });

      this.connection.onclose(async () => { 
        this.remsg += "<br>断开连接";
        this.Reconnect();
      });
      this.monitorSocket() 

    }
  	


    //在页面加载时读取sessionStorage里的状态store信息
    if (sessionStorage.getItem("store")) { 
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      ); 
      document.title = this.$store.state.troopInfo.TroopsName+'-SAS应急单兵作战系统'
    }
    //在页面刷新之前将vuex里的信息保存到sessionStorage
    window.addEventListener("beforeunload", () => { 
      //删除TeamMemberLists防止刷新时二次报警
      let state = this.$store.state
      delete state.TeamMemberLists 
      sessionStorage.setItem("store", JSON.stringify(state));   
    });


  
  	let urlToken = this.getQueryVariable('token')
  	if(urlToken){  
  		//地址栏有账户登录操作
  		let userNameArr = decodeURIComponent(urlToken).split("@")   
  		LoginService.Login({
          userName:userNameArr[0],
          password:userNameArr[1]
        }).then(
          res => {
            if (res.status == 200 && res.data.status == 1000) {
              let AccountToken = res.data.data.AccountToken;
              sessionStorage.setItem("Authorization", AccountToken);  
              LoginService.GetTroopInfo().then(
                res=>{ 
                  this.$store.commit("setTroopInfo", res.data.data); 
                  document.title = res.data.data.TroopsName+'-SAS应急单兵作战系统';
                  let res2 = res;
                  AllTeamService.getAllTeamList().then(
      				      res => {
      				        if (res.status == 200 && res.data.status == 1000) { 
                        this.$store.commit("setTeamMemberLists", res.data.data); 
                        //获取到队员数据后在进入首页
                        let type = this.getQueryVariable('type')                                     
                        if(type==1){  
                          this.$router.push({name: "home", params:{
                            lnglat:{lng:res2.data.data.AmapLng,lat:res2.data.data.AmapLat}
                          }}).catch(err => {console.error(err)});  
                        }
                      } else if (res.status == 200) {
                        this.$message.warning(res.data.msg);
                      } else {
                        this.$message.warning(res.message);
                      }
      				      },
      				      err => {
      				        this.$message.warning(err.message);
      				      }
      				    ); 
 
                  if(this.connection){
                    try{
                      this.connection.stop();
                    }catch{

                    }
                    this.connection = null;
                  }
                  //重新监听socket
	                this.connection = new signalR.HubConnectionBuilder()
        					  .withUrl(url, {
        					    accessTokenFactory() {  
                        return sessionStorage.getItem("Authorization"); 
        					    }
        					}).build()
        					this.connection.keepAliveIntervalInMilliseconds = 12e4;
        					this.connection.serverTimeoutInMilliseconds = 24e4;
        					this.connection.start().catch(err =>{
                    setTimeout(()=>{
                      this.Reconnect()
                    },4000)
                  });
                  this.connection.onclose(async () => { 
                    this.remsg += "<br>断开连接";
                    this.Reconnect();
                  });
					        this.monitorSocket() 

                },
                err=>{

                }
              ) 
              let unitname = this.getQueryVariable('unitname')
              if(unitname){
              	//地址栏有模型
              	let floorFlag=false 
              	 BuildService.getAllList().then(
			      res => {
			        if (res.status == 200 && res.data.status == 1000) {
			        	for (var i = 0; i < res.data.data.length; i++) { 
			        		if(res.data.data[i].Name == decodeURIComponent(unitname)){
			        			floorFlag=true
			        			BuildService.getJsonDataById({ ID: res.data.data[i].ID }).then(
							        res => {
							          if (res.status == 200 && res.data.status == 1000) {
							            //根据id获取到楼层信息之后需要再次把楼层信息发送给后台保存最新的楼层  
							            BuildService.saveLastLoadData({jsondata:res.data.data.JsonData}).then( 
							              res=>{
							                if (res.status == 200 && res.data.status == 1000) { 
							                  this.$router.push({
							                    name: "home",
							                    params:{
							                      floorData:res.data.data
							                    }
							                  }).catch(err => {console.error(err)});
							                } else if (res.status == 200) {
							                  this.$message.warning(res.data.msg);
							                } else {
							                  this.$message.warning(res.message);
							                }
							              },
							              err=>{
							                this.$message.warning(err.message);
							              }
							            ) 
							            
							          } else if (res.status == 200) {
							            this.$message.warning(res.data.msg);
							          } else {
							            this.$message.warning(res.message);
							          }
							        },
							        err => {
							          this.$message.warning(err.message);
							        }
							    );
			        		}
			        	} 
			        	if(!floorFlag){
			        		//地址栏有经纬度 且有建筑 
	              	let lng = this.getQueryVariable('lng')
	              	let lat = this.getQueryVariable('lat') 
	              	if(lng && lat){    

                    BuildService.getByUnitName(unitname).then(
                      res=>{   
                        if (res.status == 200) {  
                          if(res.data){
                            let flag = res.data.data==null?false:true
                            localStorage.setItem("xfwebImg", JSON.stringify(res.data.data))
                            this.$router.push({
                              name: "buildMake",
                              query: { type:'machine',Name:this.getQueryVariable('unitname')==false?'':decodeURI(this.getQueryVariable('unitname')), location: JSON.stringify({Q:lat,R:lng,lng:lng,lat:lat}),f:flag}
                            }).catch(err => {console.error(err)});
                          } 
                        } else {
                          this.$router.push({
                            name: "buildMake",
                            query: { type:'machine',Name:this.getQueryVariable('unitname')==false?'':decodeURI(this.getQueryVariable('unitname')), location: JSON.stringify({Q:lat,R:lng,lng:lng,lat:lat}),f:false}
                          });
                        }
                      },
                      err=>{
                        this.$router.push({
                          name: "buildMake",
                          query: { type:'machine',Name:this.getQueryVariable('unitname')==false?'':decodeURI(this.getQueryVariable('unitname')), location: JSON.stringify({Q:lat,R:lng,lng:lng,lat:lat}),f:false}
                        });
                      }
                    ) 
	              	}
			        	}
			        } else if (res.status == 200) {
			          this.$message.warning(res.data.msg);
			        } else {
			          this.$message.warning(res.message);
			        }
			      },
			      err => {
			        this.$message.warning(err.message);
			      }
			    );
              }else{
              	//地址栏有经纬度 但是没有建筑
              	let lng = this.getQueryVariable('lng')
              	let lat = this.getQueryVariable('lat')
              	if(lng && lat){ 
              		this.$router.push({
			            name: "buildMake",
			            query: { type:'machine',Name:this.getQueryVariable('unitname')==false?'':decodeURI(this.getQueryVariable('unitname')), location: JSON.stringify({Q:lat,R:lng,lng:lng,lat:lat})}
			        }).catch(err => {console.error(err)});
              	}
              } 
            } else if (res.status == 200) {
              this.$router.push({ name: "Login" }).catch(err => {console.error(err)});
            } else {
              this.$router.push({ name: "Login" }).catch(err => {console.error(err)});
            }
          },
          err => {
            this.$router.push({ name: "Login" }).catch(err => {console.error(err)});
          }
        );
  	}else{ 
      //this.getAllTeamList()
    } 




    window.onresize = () => {
      this.ScreenWidth = document.body.clientWidth;
    };


    let token = sessionStorage.getItem("Authorization"); 
    if (!!!token) { 
      this.$router.push({ name: "Login" }).catch(err => {console.error(err)});
      return false;
    } 

    this.$message.config({
      maxCount: 1
    });  
 
  },
  computed: {
    TeamMemberList() {
      return this.$store.state.TeamMemberList;
    },
    TeamMemberLists() {
      return this.$store.state.TeamMemberLists;
    },
    ConfigList() {
      return this.$store.state.Config;
    },
    getManualGroup() {
      return function(groupName, name) {
        if (groupName.substring(groupName.length - 1) == "组") {
          return groupName + " " + name;
        } else {
          return groupName + "组 " + name;
        }
      };
    },
    ReccoTeamMemberList() {
      return this.$store.state.ReccoTeamMemberList;
    },
    LocationInfo(){
      return this.$store.state.LocationInfo
    } 
  }, 
  mounted() { 
    
    this.pathName = this.$route.name;

    let troopInfo = this.$store.state.troopInfo 
    if(troopInfo){
    	setTimeout(() => {
	      let troopsID = troopInfo.TroopsID;
	      SetupService.getSetupList({ TroopsID: troopsID }).then(
	        res => {
	          if (res.status == 200 && res.data.status == 1000) {
	            this.$store.commit("setConfig", res.data.data);
	          } else if (res.status == 200) {
	            self.$message.warning(res.data.msg);
	          } else {
	            self.$message.warning(res.message);
	          }
	        },
	        err => {
	          this.$message.warning(err.message);
	        }
	      );
	    }, 200);
    }
    

    this.setIntervalGetTroopsTeamMemberStatus = setInterval(()=>{
      this.intervalGetTroopsTeamMemberStatus()
    },30000)
  },
  beforeDestroy(){  
    clearInterval(this.setIntervalGetTroopsTeamMemberStatus)
  },
  methods: {
    getAllTeamList(){ 
      AllTeamService.getAllTeamList().then(
        res => {
          if (res.status == 200 && res.data.status == 1000) { 
            this.$store.commit("setTeamMemberLists", res.data.data);  
          } else if (res.status == 200) {
            this.$message.warning(res.data.msg);
          } else {
            this.$message.warning(res.message);
          }
        },
        err => {  
          if (err && err.stack.indexOf('timeout') > -1) {  
             this.getAllTeamList()
          }else{
            this.$message.warning(err.message)
          } 
        }
      ) 
    },
  	monitorSocket(){
  		this.connection.on("Message", (type, message) => {
	      //呼救器数据
	      if (type == "data") { 
	        let objData = this.getDataByCode(message); 
	        if (objData.Type == 1) {
	          	//console.log(objData.SN + "-----" + objData.UDTime);

	          	for (let i = 0; i < this.UDTime.length; i++) {
	          		if(this.UDTime[i].SN == objData.SN){    
	          			if(new Date(this.UDTime[i].UDTime) < new Date(objData.UDTime)){  
	          				this.$store.commit("setReccoTeamMemberList", this.getDatas(objData,message));
	          			}
	          		}
	          	} 

	          	let udTimeObj = {SN:objData.SN,UDTime:objData.UDTime}  
	          	let flag = false
	          	for (let i = 0; i < this.UDTime.length; i++) { 
	          		if(this.UDTime[i].SN == objData.SN){  
	          			flag=true
	          			this.UDTime.splice(i,1,udTimeObj) 
	          		} 
	          	} 
	          	if(!flag){
	          		this.UDTime.push(udTimeObj) 
	          	} 
	        }
	      }
	    });
	    this.connection.on("SendMessage", (type, message) => {
	      if (type == "Location") { 
	      	
	        //定位器数据   
	        let objData = JSON.parse(message)   
          if(objData.SN=='S0130000524'){   
              //console.log('SN:'+objData.SN + ' X:'+objData.X+' Y:'+objData.Y+' Z:'+objData.Z +','+objData.IsInit+','+objData.IsLocationReset)
             
          }
          

	        for (let i = 0; i < this.locationTime.length; i++) {
	      		if(this.locationTime[i].SN == objData.SN){     
	      			if(new Date(this.getTimes(new Date(this.locationTime[i].UDTime.toString().replace(/\T/g," ").replace(/\Z/g," ")).getTime())) < new Date(this.getTimes(new Date(objData.UDTime.toString().replace(/\T/g," ").replace(/\Z/g," ")).getTime()))){  
	      				this.$store.commit("setLocationInfo", JSON.parse(message)) 
	      			}
	      		}
	      	} 

	      	let locationTimeObj = {SN:objData.SN,UDTime:objData.UDTime}  
	      	let flag = false
	      	for (let i = 0; i < this.locationTime.length; i++) { 
	      		if(this.locationTime[i].SN == objData.SN){  
	      			flag=true
	      			this.locationTime.splice(i,1,locationTimeObj) 
	      		} 
	      	} 
	      	if(!flag){
	      		this.locationTime.push(locationTimeObj) 
	      	} 
	      }else if(type == "LocationReset"){ 
	      	let resetSNArr = message.split(' ')[1]
	      	let resetSN = resetSNArr.slice(0,1) + 'N' + resetSNArr.slice(1) 
	      	document.getElementById('page3d').contentWindow.postMessage({type:'locationReset',data:resetSN}, '/')
	      }else {
	        //搜救数据
	        let msg = message.split(" ");
	        let rescueErr = {};
	        for (var i = 0; i < this.TeamMemberLists.length; i++) {
	          if (this.TeamMemberLists[i].SN == "S0" + msg[0]) {
	            rescueErr.GroupName = this.TeamMemberLists[i].GroupName;
	            rescueErr.Name = this.TeamMemberLists[i].Name;
	            rescueErr.msg = msg[1];
	          }
	        }
	        this.rescueErrMsg = rescueErr;
	      }
	    });
  	},
  	intervalGetTroopsTeamMemberStatus(){
      //30秒请求一次获取最新的状态
      HomeService.getTroopsTeamMemberStatus().then( 
        res => { 
            if (res.status == 200) {
              if(res.data.status == 1000) {    
              	let serverTime = this.getTimes(res.data.time)
                for (var i = 0; i < (this.TeamMemberLists==null?0:this.TeamMemberLists.length); i++) {
                  for (var j = 0; j <res.data.data.length; j++) { 
                    if(this.TeamMemberLists[i].SN == res.data.data[j].SN){ 
                      Vue.set(this.TeamMemberLists[i],'UDTime',res.data.data[j].UpdatedTime) 



	                  if(this.TeamMemberLists[i].UDTime ==undefined || parseInt(new Date(serverTime) - new Date(this.TeamMemberLists[i].UDTime))/1000 > 65){  
				          Vue.set(this.TeamMemberLists[i],'isOnLine',true)    
				        }else{
				        	Vue.set(this.TeamMemberLists[i],'AlarmStatus',res.data.data[j].AlarmStatus)  
				          Vue.set(this.TeamMemberLists[i],'isOnLine',false)
				        } 

                       



                      Vue.set(this.TeamMemberLists[i],'Temperature',res.data.data[j].Temperature)
                      Vue.set(this.TeamMemberLists[i],'ICUEle',res.data.data[j].ICUEle)
                      Vue.set(this.TeamMemberLists[i],'WorkTime',res.data.data[j].WorkTime)
                      Vue.set(this.TeamMemberLists[i],'ICUVolt',res.data.data[j].ICUVolt)
                      Vue.set(this.TeamMemberLists[i],'RelativelyHigh',res.data.data[j].RelativelyHigh)
                      Vue.set(this.TeamMemberLists[i],'Altitude',res.data.data[j].Altitude) 
                      Vue.set(this.TeamMemberLists[i],'GPSLong',res.data.data[j].GPSLong)
                      Vue.set(this.TeamMemberLists[i],'GPSLat',res.data.data[j].GPSLat)
                      Vue.set(this.TeamMemberLists[i],'GPAHigh',res.data.data[j].GPAHigh) 
                      Vue.set(this.TeamMemberLists[i],'Device',res.data.data[j].Device)
                      Vue.set(this.TeamMemberLists[i],'DeviceEle',res.data.data[j].DeviceEle)
                      Vue.set(this.TeamMemberLists[i],'DeviceHeartRate',res.data.data[j].DeviceHeartRate)
                      Vue.set(this.TeamMemberLists[i],'DeviceTemperature',res.data.data[j].DeviceTemperature)
                      Vue.set(this.TeamMemberLists[i],'DeviceBloodOxygen',res.data.data[j].DeviceBloodOxygen) 
                      Vue.set(this.TeamMemberLists[i],'GASPressure',res.data.data[j].GASPressure)
                      Vue.set(this.TeamMemberLists[i],'GASRemainingTime',res.data.data[j].GASRemainingTime)
                      Vue.set(this.TeamMemberLists[i],'GASEle',res.data.data[j].GASEle)  
                    }
                  }  
                  
                } 
              } else {
                this.$message.warning(res.data.msg)
              }
            } else {
              this.$message.warning(res.message)
            }
        },
        err => {
          if (err && err.stack.indexOf('timeout') > -1) { 
            //this.intervalGetTroopsTeamMemberStatus()
            //this.$message.warning('请求超时,请重试')
          }  
           
        }  
      ) 
    },
    getQueryVariable(variable){
       var query = this.query  
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
       }
       return(false);
	},
    Reconnect() {
      /*try {
        this.connection.start();
      } catch (err) { 
        setTimeout(() => this.Reconnect(), 5000);
      }*/
      this.connection.start().catch(err => {
        setTimeout(()=>{
          this.Reconnect()
        },4000)
      })
    },
    RSPlayer() {
      this.routers("RVideo");
    },
    RSUAVVideo() {
      if (this.ISElectron) {
        ipc.openUAV();
      }
    },

    routers(param) { 
      let _this = this; 
      if (this.$route.name == "buildMake") {
        this.$confirm({
          title: "确定离开当前页面",
          content: "如果有建模的数据将会丢失",
          okText: "确定",
          cancelText: "取消",
          centered: true,
          width: 320,
          onOk() {  
            _this.$router.push({
              name:param
            }).catch(err => {console.error(err)});
          }
        });
      } else {
        if (param == "build") {
          if (sessionStorage.getItem("isBuildList")) {
            param = "buildList";
          } else {
            param = "builds";
          }
        }
        if(this.$route.name == param){
          return;
        } 
        this.$router.push({
          name: param
        }).catch(err => {console.error(err)});
      }
    },
    getArrData(param) {
      var str = "";
      for (var i = 0; i < param.length; i++) {
        if (i % 2 == 0 && i != 0) {
          str += ",";
        }
        str += param[i];
      }
      return str.split(",");
    },
    getDatas(objData,msg) {   
      var arrData = this.getArrData(objData.Content); 
   
      for (var i = 0; i < arrData.length; i++) {
   
        let type = parseInt(arrData[i], 16);
        let len = parseInt(arrData[i + 1], 16);
        switch (type) {
          case 16:
            //互救器信息
            if (len == 12) {
              objData.AlarmStatus = parseInt(arrData[i + 2], 16);
              objData.Temperature = parseInt(arrData[i + 3], 16);
              objData.ICUEle = parseInt(arrData[i + 4], 16);
              objData.WorkTime = parseInt(arrData[i + 5] + arrData[i + 6], 16);
              objData.ICUVolt = parseInt(arrData[i + 7] + arrData[i + 8], 16);
              if (parseInt(arrData[i + 9], 16) == 1) {

              	if(parseInt(arrData[i + 10] + arrData[i + 11],16) > 32768){
              		objData.RelativelyHigh = ((parseInt(arrData[i + 10] + arrData[i + 11],16)-65535) * 0.1).toFixed(1);
              	}else{
              		objData.RelativelyHigh = (parseInt(
	                  arrData[i + 10] + arrData[i + 11],
	                  16
	                ) * 0.1).toFixed(1);
              	}
                
              }
              objData.Altitude =
                (parseInt(arrData[i + 12] + arrData[i + 13], 16) * 0.1).toFixed(1);
            }
            break;
          case 17: 
            //位置信息 
            if (len == 15 && parseInt(arrData[i + 2], 16) == 1) {  
              objData.GPSLong = Math.abs(
                this.hexToSingle(
                  arrData[i + 4]+
                  arrData[i + 5]+
                  arrData[i + 6]+
                  arrData[i + 7]
                )
              );
              objData.GPSLat = Math.abs(
                this.hexToSingle(
                  arrData[i + 9]+
                    arrData[i + 10]+
                    arrData[i + 11]+
                    arrData[i + 12]
                )
              );
              objData.GPSHigh = this.hexToSingle(
                arrData[i + 13]+
                arrData[i + 14]+
                arrData[i + 15]+
                arrData[i + 16]
              );
              if (arrData[1] == "W") {
                objData.GPSLong = -objData.GPSLong;
              }
              if (arrData[6] == "S") {
                objData.GPSLat = -objData.GPSLat;
              }  
            } 
            break;
          case 18: 
            //手环信息
            
            if ((len == 3 || len == 6) && (parseInt(arrData[i + 2], 16) == 1 || parseInt(arrData[i + 2], 16) == 2)) {    
              objData.Device = parseInt(arrData[i + 2], 16);
              objData.DeviceEle = parseInt(arrData[i + 3], 16);
              objData.DeviceHeartRate = parseInt(arrData[i + 4], 16);
              if (len == 6) {
                objData.DeviceTemperature = parseInt(
                  arrData[i + 5] + arrData[i + 6],
                  16
                )/10;
                objData.DeviceBloodOxygen = parseInt(arrData[i + 7], 16);
              }
            }
            break;
          case 19:
            //气瓶信息
            if (len == 5 && parseInt(arrData[i + 2], 16) == 1) {
            	objData.GASIsOnLine = true
              objData.GASPressure = (parseInt(
                arrData[i + 3] + arrData[i + 4],
                16
              ) * 0.1).toFixed(1);
              objData.GASRemainingTime = parseInt(arrData[i + 5], 16);
              objData.GASEle = parseInt(arrData[i + 6], 16);
            }else{
            	objData.GASIsOnLine = false
            }
            break;
          case 20:
            //正在施救的信息
            if (len == 5 && parseInt(arrData[i + 2], 16) != 0) {
              objData.Rescuing.SnNum = parseInt(
                arrData[i + 2] +
                  arrData[i + 3] +
                  arrData[i + 4] +
                  arrData[i + 5],
                16
              );
              objData.Rescuing.Signal = parseInt(arrData[i + 6], 16);
            }
            break;
          case 21:
            if (len == 5 || len == 10 || len == 15) {
              let waitRescues = [];
              for (let j = 0; j < len; j += 5) {
                waitRescues.push(
                  parseInt(
                    arrData[i + 2 + j] +
                      arrData[i + 3 + j] +
                      arrData[i + 4 + j] +
                      arrData[i + 5 + j],
                    16
                  )
                );
              }
              objData.WaitRescues = waitRescues;
            }
            break;
          case 22:
            if (len == 5 || len == 10 || len == 15) {
              let saveMeRescues = [];
              for (let j = 0; j < len; j += 5) {
                saveMeRescues.push(
                  parseInt(
                    arrData[i + 2 + j] +
                      arrData[i + 3 + j] +
                      arrData[i + 4 + j] +
                      arrData[i + 5 + j],
                    16
                  )
                );
              }
              objData.SaveMeRescues = saveMeRescues;
            }
            break;
          case 23:
            break;
          case 25: 
            if (len == 10 && parseInt(arrData[i + 2], 16) == 1) { 
              objData.GasDetectorIsOnLine=true
              objData.CarbonMonoxide = (parseInt(arrData[i + 3]+arrData[i + 4], 16)/10).toFixed()
              objData.Oxygen = (parseInt(arrData[i + 5]+arrData[i + 6], 16)/10).toFixed(1)
              objData.CombustibleGas = (parseInt(arrData[i + 7]+arrData[i + 8], 16)/10).toFixed(1)
              objData.HydrogenSulfide = (parseInt(arrData[i + 9]+arrData[i + 10], 16)/10).toFixed(1)
              objData.GasDetectorEle = parseInt(arrData[i + 11], 16)
            }else{ 
              objData.GasDetectorIsOnLine=false
            }
            break;
          case 26: 
            if (len == 2) {
              let state = parseInt(arrData[i + 2]+arrData[i + 3],16) 
              if(state == 65535){ 
                let teamMemberLists = this.$store.state.TeamMemberLists 
                for (let i = 0; i < (teamMemberLists==null?0:teamMemberLists.length); i++) {
                  if(objData.SN == teamMemberLists[i].SN){ 
                    Vue.set(teamMemberLists[i],'DepartDuration',null)
                    Vue.set(teamMemberLists[i],'DepartDuration_AI',null) 
                    Vue.set(teamMemberLists[i],'IsInside',false)
                  }
                } 
                delete this.workState[objData.SN]
                if(this.workStateInterval[objData.SN]){
                  clearTimeout(this.workStateInterval[objData.SN]) 
                }
              }else{
                if(this.workState[objData.SN]==undefined){
                  this.workState[objData.SN] = state 
                  this.workStateInterval[objData.SN] = setInterval(()=>{   
                    let teamMemberLists = this.$store.state.TeamMemberLists 
                    for (let i = 0; i < (teamMemberLists==null?0:teamMemberLists.length); i++) {
                      if(objData.SN == teamMemberLists[i].SN){ 
                        Vue.set(teamMemberLists[i],'DepartDuration',-1)
                        Vue.set(teamMemberLists[i],'DepartDuration_AI',this.workState[objData.SN])
                        Vue.set(teamMemberLists[i],'IsInside',true)
                        this.workState[objData.SN]++ 
                      }
                    } 
                  },1000)
                  
                }else{

                }

              }
            }
            break;
        }
      }

      return objData;
    },
    hexToSingle(a){ 
      var b = parseInt(a,16)
      var s = b&0x80000000/0x80000000
      var e = (b&0x7f800000)/0x800000-127
      var c = (b&0x7fffff)/0x800000
      var re = Math.pow(-1,s)*(1+c)*Math.pow(2,e)
      return parseFloat(re.toString(10))
    },
    getDataByCode(msg) {
      let obj = {};
      obj.Type = parseInt(msg.slice(0, 2), 16);
      obj.SN = "S0" + parseInt(msg.slice(2, 10), 16);

      let allTeamMember = this.$store.state.AllTeamMember;
      for (var i = 0; i < allTeamMember.length; i++) {
        if (allTeamMember[i].SN == obj.SN) {
          obj.GroupName = allTeamMember[i].GroupName;
        }
      }
      obj.Pack = parseInt(msg.slice(10, 18), 16); 
      obj.UDTime = this.getTimes(parseInt(msg.slice(18,26),16));
      obj.Time = this.getTimes(new Date().getTime()); 
      obj.Len = parseInt(msg.substr(26, 4), 16);
      obj.Content = msg.substr(30, obj.Len * 2);
      obj.Code = parseInt(msg.substr(30 + obj.Len * 2, 2), 16);
      return obj;
    },

    move(e) {
      this.elen.style.left = e.touches[0].clientX - (this.X - this.left) + "px";
      this.elen.style.top = e.touches[0].clientY - (this.Y - this.top) + "px";
    },
    end() {
      this.elen.removeEventListener("touchmove", this.move);
      this.elen.removeEventListener("touchend", this.end);
    },
    down(e) {
      this.elen = e.currentTarget.parentNode;
      this.left = this.elen.getBoundingClientRect().left;
      this.top = this.elen.getBoundingClientRect().top;
      this.X = e.touches[0].clientX;
      this.Y = e.touches[0].clientY;
      this.elen.style.zIndex = this.showIndex;
      this.showIndex++;
      this.elen.style.margin = 0;
      this.elen.style.left = e.touches[0].clientX - (this.X - this.left) + "px";
      this.elen.style.top = e.touches[0].clientY - (this.Y - this.top) + "px";
      this.elen.addEventListener("touchmove", this.move, false);
      this.elen.addEventListener("touchend", this.end, false);
    },
    //通过当前时间跟后台刷新时间判断是否下线
    timeDrop(t) {
      if (t != null) {
        return (
          parseInt(
            new Date(this.getTimes()) - new Date(this.getTimes(t.UpdateTime))
          ) /
            1000 >
          30
        );
      } else {
        return true;
      }
    },
    getTimes(data, type) {
      var _data = data;
      //如果是13位正常，如果是10位则需要转化为毫秒
      if (data == undefined) {
        const time = new Date();
        const Y = time.getFullYear();
        const Mon = time.getMonth() + 1;
        const Day = time.getDate();
        const H = time.getHours();
        const Min = time.getMinutes();
        const S = time.getSeconds();
        return `${Y}/${Mon}/${Day} ${H}:${Min}:${S}`;
      } else {
        if (String(data).length == 13) {
          _data = data;
        } else {
          _data = data * 1000;
        }
        const time = new Date(_data);
        const Y = time.getFullYear();
        const Mon = time.getMonth() + 1;
        const Day = time.getDate();
        const H = time.getHours();
        const Min = time.getMinutes();
        const S = time.getSeconds();
        if (type == "Y") {
          return `${Y}-${Mon}-${Day}`;
        } else if (type == "H") {
          return `${H}:${Min}:${S}`;
        } else {
          return `${Y}/${Mon}/${Day} ${H}:${Min}:${S}`;
        }
      }
    },
    okSos(e, sn, group, index, alarmStatus, relativeHeight,Altitude) {
      let _this = this;
      if (this.$route.name == "buildMake") {
        this.$confirm({
          title: "确定离开当前页面",
          content: "如果有建模的数据将会丢失",
          okText: "确定",
          cancelText: "取消",
          centered: true,
          width: 320,
          onOk() {
            e.target.parentNode.parentNode.style.display = "none";
            e.target.parentNode.parentNode.nextElementSibling.style.display =
              "none";
            _this.$router.push({
              name: "rescue",
              query: {
                sn: sn,
                group: group,
               /* index: _this.groupName.indexOf(group),
                relativeHeight: relativeHeight==null || relativeHeight==undefined?Altitude:relativeHeight*/
              }
            }).catch(err => {console.error(err)});
            /*if(alarmStatus == 6){ 
		  			HomeService.automaticStrongAlarmBySN({SN:sn}).then(
			  			res => { 
				        if (res.status == 200) {
				          if (res.data.status == 1000) {   
						        
				          } else if (res.status == 200){
				          	_this.$message.warning(res.data.msg)
				          }
				        } else {
				        	_this.$message.warning(res.message)
				        }
				      },
				      err => {
				        _this.$message.warning(err.message)
				      }
			  		)
		  		}else if(alarmStatus == 3){ 
		  			HomeService.manualAlarmBySN({SN:sn}).then(
			  			res => { 
				        if (res.status == 200) {
				          if (res.data.status == 1000) {   
						        
				          } else if (res.status == 200){
				          	_this.$message.warning(res.data.msg)
				          }
				        } else {
				        	_this.$message.warning(res.message)
				        }
				      },
				      err => {
				        _this.$message.warning(err.message)
				      }
			  		)
		  		}*/
          }
        });
      } else {
        e.target.parentNode.parentNode.style.display = "none";
        e.target.parentNode.parentNode.nextElementSibling.style.display =
          "none";
        this.$router.push({
          name: "rescue",
          query: {
            sn: sn,
            group: group,
            /*index: this.groupName.indexOf(group),
            relativeHeight: relativeHeight*/
          }
        }).catch(err => {console.error(err)});
        /*if(alarmStatus == 6){ 
	  			HomeService.automaticStrongAlarmBySN({SN:sn}).then(
		  			res => { 
			        if (res.status == 200) {
			          if (res.data.status == 1000) {   
					        
			          } else if (res.status == 200){
			          	this.$message.warning(res.data.msg)
			          }
			        } else {
			        	this.$message.warning(res.message)
			        }
			      },
			      err => {
			        this.$message.warning(err.message)
			      }
		  		)
	  		}else if(alarmStatus == 3){ 
	  			HomeService.manualAlarmBySN({SN:sn}).then(
		  			res => { 
			        if (res.status == 200) {
			          if (res.data.status == 1000) {   
					        
			          } else if (res.status == 200){
			          	this.$message.warning(res.data.msg)
			          }
			        } else {
			        	this.$message.warning(res.message)
			        }
			      },
			      err => {
			        this.$message.warning(err.message)
			      }
		  		)
	  		}*/
      }
    },
    //隐藏SOS报警框
    cancalSos(e, alarmStatus) {
      e.target.parentNode.parentNode.getElementsByTagName("p")[0].innerHTML =
        "取消SOS成功,正在关闭...";
      e.target.parentNode.parentNode.getElementsByTagName(
        "p"
      )[0].style.fontSize = "35px";
      e.target.parentNode.parentNode.getElementsByTagName("p")[0].style.color =
        "#ccc";
      setTimeout(() => {
        e.target.parentNode.parentNode.style.display = "none";
        e.target.parentNode.parentNode.nextElementSibling.style.display =
          "none";
      }, 100);
    },
    //隐藏报警框
    closeCall(e) {
      e.target.parentNode.parentNode.style.display = "none";
      e.target.parentNode.parentNode.nextElementSibling.style.display = "none";
      /*if(document.getElementById('page3d') != null){
  			document.getElementById('page3d').contentWindow.postMessage({type:'isCalibrationPage'}, '/')
  		}*/
    },
    closeManual() {
      this.rescueErrMsg = {};
    },
    reload() {
      this.isReload = false;
      this.$nextTick(function() {
        this.isReload = true;
      });
    },
    allRetreat() {
      this.isRetreat = true;
      this.retreatMsg = "是否发出全撤命令？";
    },
    okRetreat() {
      //全部撤退
      this.setTeamMemberList3 = [];
      //this.$store.commit('setTeamMemberList3', [])
      this.$store.commit("clearIsResponse");
      this.isRetreat = false;
      this.retreatIcon = true;
      this.$message.success("已发送") 
      HomeService.memberWithdraw({ withdrawType: 3 }).then(
        res => {
          if (res.status == 200) {
            if (res.data.status == 1000) {
              this.$store.commit("setAllRetreatFlag", true);
              for (let i = 0; i < this.TeamMemberLists.length; i++) {
                this.$store.commit(
                  "setAllRetreatOnLineSN",
                  this.TeamMemberLists[i].SN
                );
              }

              
            } else if (res.status == 200) {
              this.$message.warning(res.data.msg);
            } else {
              this.$message.warning(res.message);
            }
          }
        },
        err => {
          this.$message.warning(err.message);
        }
      );
    },
    cancalRetreat() {
      this.isRetreat = false;
    },

    GetConfig() {
      SetupService.GetConfig().then(
        res => {
          if (res.status == 200) {
            if (res.data.status == 1000) {
              if (res.data.data) {
                this.$store.commit("setConfig", res.data.data);
              } else {
                setTimeout(() => {
                  this.GetConfig();
                }, 5000);
              }
            }
          } else {
            setTimeout(() => {
              this.GetConfig();
            }, 5000);
          }
        },
        err => {
          setTimeout(() => {
            this.GetConfig();
          }, 5000);
        }
      );
    },
    GetCurrentLocation() {
      SetupService.GetCurrentLocation().then(
        res => {
          if (res.status == 200) {
            if (res.data.status == 1000) {
              if (res.data.data) {
                this.$store.commit("setCurrentLocation", res.data.data);
              } else {
                setTimeout(() => {
                  this.GetCurrentLocation();
                }, 5000);
              }
            }
          } else {
            setTimeout(() => {
              this.GetCurrentLocation();
            }, 5000);
          }
        },
        err => {
          setTimeout(() => {
            this.GetCurrentLocation();
          }, 5000);
        }
      );
    },
    getFloors(floors,teamMemberList){  
      if(floors==null || !floors.length){
        return
      }  
       
      let Altitude 
      if(teamMemberList.Location && teamMemberList.Location.Z != null){ 
        Altitude = teamMemberList.Location.Z
      }else{ 
        Altitude = 0
      }  

      let floorsArr=[] 
      let total=0
      let floor=0  
      let firstFloorHeight=0
      let flag=false
      let isPositive=true  
      let index=0 
      for (var i = 0; i < floors.length; i++) { 
        for(var j = floors[i].start; j <= floors[i].end; j++){ 
          if(j != 0){ 
            let floorsObj={}
            if(floors[0].start　< 0){
              isPositive=false
            }
            if(floors[0].start == j && Altitude >= 0){  
              floorsObj.high = floors[i].high * 0.8
              firstFloorHeight = floors[i].high - floors[i].high * 0.8
            }else if(floors[0].start == j && Altitude < 0){ 
              floorsObj.high = floors[i].high * 1.2
              firstFloorHeight = floors[i].high * 1.2 - floors[i].high
            }else{
              floorsObj.high = floors[i].high
            }
            
            floorsObj.floor = j
            floorsArr.push(floorsObj)
          } 
        }
      }    

      if(Altitude>=0){
        for (let i = 0; i < floorsArr.length; i++) {
          if(floorsArr[i].floor>0){ 
            if(isPositive){ 
              total += floorsArr[i].high
            }else{    
              if(index==0){    
                total += floorsArr[i].high-firstFloorHeight
              }else{  
                total += floorsArr[i].high
              }
              
            } 
            index++
            floor++ 
            if(isPositive){
              if(Altitude < total){  
                return floor
              }
            }else{
              if(Altitude <= total){  
                return floor
              }
            }
              
          }  
        }
        if(floorsArr[floorsArr.length-1].floor<0){ 
          return floorsArr[floorsArr.length-1].floor
        } 
        if(Altitude > total){  
          return floor
        }
      }else{
        for (let i = 0; i < floorsArr.length; i++) {
          
          if(floorsArr[i].floor<0){  
            flag=true 
            if(Altitude > -firstFloorHeight){
              return 1
            }
            total -= floorsArr[i].high
            floor -- 
            if(Altitude > total){  
              return floor
            }
          } 
        } 
        if(Altitude < total){   
          if(flag) {
            return floor 
          }else{
            return floor+1 
          }
          
        }
      }
    }
  },
  watch: {
    $route(to, from) {
      this.pathName = to.name;
    },
    TeamMemberList(to, from) {
      let newArr = [];
      for (let i = 0; i < this.TeamMemberList.length; i++) {
        if (this.TeamMemberList[i].IsInit) {
          if (newArr.indexOf(this.TeamMemberList[i].GroupName) == "-1") {
            newArr.push(this.TeamMemberList[i].GroupName);
          }
        }
      }
      this.groupName = newArr;
    },
    ReccoTeamMemberList(to, from) {
    	if(this.TeamMemberLists != null){
 
          for (var i = 0; i < this.TeamMemberLists.length; i++) {
            if (this.TeamMemberLists[i].SN == to.SN) {
              //呼救器信息
              Vue.set(this.TeamMemberLists[i], "UDTime", to.Time);
              Vue.set(this.TeamMemberLists[i], "SN", to.SN);
              Vue.set(this.TeamMemberLists[i], "AlarmStatus", to.AlarmStatus);
              Vue.set(this.TeamMemberLists[i], "Temperature", to.Temperature);
              Vue.set(this.TeamMemberLists[i], "ICUEle", to.ICUEle);
              Vue.set(this.TeamMemberLists[i], "WorkTime", to.WorkTime);
              Vue.set(this.TeamMemberLists[i], "ICUVolt", to.ICUVolt);
              Vue.set(this.TeamMemberLists[i], "RelativelyHigh", to.RelativelyHigh);
              Vue.set(this.TeamMemberLists[i], "Altitude", to.Altitude);

              Vue.set(this.TeamMemberLists[i], "GPSLong", to.GPSLong);
              Vue.set(this.TeamMemberLists[i], "GPSLat", to.GPSLat);
              Vue.set(this.TeamMemberLists[i], "GPSHigh", to.GPSHigh);
              //手环耳机信息
              Vue.set(this.TeamMemberLists[i], "Device", to.Device);
              Vue.set(this.TeamMemberLists[i], "DeviceEle", to.DeviceEle);
              Vue.set(
                this.TeamMemberLists[i],
                "DeviceHeartRate",
                to.DeviceHeartRate
              );
              Vue.set(
                this.TeamMemberLists[i],
                "DeviceTemperature",
                to.DeviceTemperature
              );
              Vue.set(
                this.TeamMemberLists[i],
                "DeviceBloodOxygen",
                to.DeviceBloodOxygen
              );
              //空呼气瓶信息
              Vue.set(this.TeamMemberLists[i], "GASPressure", to.GASPressure);
              Vue.set(
                this.TeamMemberLists[i],
                "GASRemainingTime",
                to.GASRemainingTime
              );
              Vue.set(this.TeamMemberLists[i], "GASEle", to.GASEle);
              Vue.set(this.TeamMemberLists[i],"GASIsOnLine",to.GASIsOnLine);
              Vue.set(this.TeamMemberLists[i], "isOnLine", false);
              Vue.set(this.TeamMemberLists[i], "isInit", true);  

              let floorNumber = this.getFloors(JSON.parse(sessionStorage.getItem('floors')),this.TeamMemberLists[i])  
                Vue.set(this.TeamMemberLists[i],'FloorNumber', floorNumber==undefined?'-':floorNumber) 


              //气体检测仪
              Vue.set(this.TeamMemberLists[i], "GasDetectorIsOnLine", to.GasDetectorIsOnLine);
              Vue.set(this.TeamMemberLists[i],"CarbonMonoxide",to.CarbonMonoxide);
              Vue.set(this.TeamMemberLists[i], "Oxygen", to.Oxygen);
              Vue.set(this.TeamMemberLists[i], "CombustibleGas", to.CombustibleGas); 
              Vue.set(this.TeamMemberLists[i], "HydrogenSulfide", to.HydrogenSulfide); 
              Vue.set(this.TeamMemberLists[i], "GasDetectorEle", to.GasDetectorEle);  
            }
          }  
    		
		  }  
    },
    LocationInfo(to,from){   

      for (var i = 0; i < (this.TeamMemberLists && this.TeamMemberLists.length); i++) {   
        if(this.TeamMemberLists[i].SN == to.SN){  
 
          let LocationInfoData={}
          LocationInfoData.TrackElec = to.TrackElec
          LocationInfoData.Posture = to.Posture
          LocationInfoData.UDTime = to.UDTime
          LocationInfoData.Z = to.Z 
          LocationInfoData.ResetStatus = to.ResetStatus


          Vue.set(this.TeamMemberLists[i],'Location',LocationInfoData)   

        } 
      } 
    }
  }
};
</script>
<style lang="less">

.clearfloat:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}
.clearfloat {
  zoom: 1;
}

.ant-btn-primary {
  background: #40dc23 !important;
  border: 0 !important;
}

#mask {
  left: 0;
  top: 0;
  z-index: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.3;
}

#maple-layout .maple-menu .maple-menu-item.active {
  background-color: #151e2d;
}
#maple-layout .maple-menu .maple-menu-item.active img.src-home {
  content: url(../assets/images/nav_icon_home_selected.png);
}
#maple-layout .maple-menu .maple-menu-item.active img.src-modeling {
  content: url(../assets/images/nav_icon_modeling_selected.png);
}
#maple-layout .maple-menu .maple-menu-item.active img.src-team {
  content: url(../assets/images/nav_icon_team_selected.png);
}
#maple-layout .maple-menu .maple-menu-item.active img.src-search {
  content: url(../assets/images/tab_search_data_ed.png);
}
#maple-layout .maple-menu .maple-menu-item.active img.src-setup {
  content: url(../assets/images/nav_icon_setup_selected.png);
}

#maple-layout .maple-menu .maple-menu-item.active img.src-RVideo{
  content: url(../assets/images/nav_video_ed.png);
}

.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow {
  left: auto !important;
  right: 40px;
}

.sos-box {
  z-index: 20;
  height: 306px;
  width: 420px;
  position: fixed;
  color: #fd1717;
  left: 50%;
  top: 50%;
  border: 1px solid #f5f5f5;
  margin-left: -210px;
  margin-top: -153px;
  background: #fff;
  border-radius: 8px;
  h3 {
    color: #fd1717;
    margin: 0;
    border-radius: 8px 8px 0 0;
    background: #151e2d;
    height: 82px;
    position: relative;
    span {
      position: absolute;
      left: 130px;
      top: 15px;
    }
    img {
      width: 80px;
      margin-left: 20px;
    }
    div {
      position: absolute;
      right: 20px;
      top: 5px;
      img {
        width: 35px;
      }
    }
  }
  p {
    text-align: center;
    font-size: 60px;
    font-weight: 600;
    line-height: 150px;
    margin: 0;
  }
  > div {
    text-align: center;
    button:first-child {
      background: #fff;
      color: #fd1717;
      border: 1px solid #fd1717;
    }
    button:last-child {
      background: #fd1717;
      color: #fff;
    }
  }
  button {
    cursor: pointer;
    font-size: 16px;
    width: 157px;
    height: 54px;
    border: 0;
    border-radius: 8px;
    margin: 0 8px;
  }
}
.monit-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: #000;
  opacity: 0.4;
  z-index: 3;
}
.monit-box {
  border: 1px solid #f5f5f5;
  z-index: 6;
  height: 324px;
  width: 420px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -210px;
  margin-top: -162px;
  background: #fff;
  border-radius: 8px;
  h3 {
    cursor: move;
    margin: 0;
    border-radius: 8px 8px 0 0;
    background: #151e2d;
    color: #6d7a86;
    height: 82px;
    position: relative;
    span {
      position: absolute;
      left: 130px;
      top: 15px;
    }
    img {
      width: 80px;
      margin-left: 20px;
    }
    div {
      position: absolute;
      right: 20px;
      top: 5px;
      img {
        width: 35px;
      }
    }
  }
  .monit-centent {
    text-align: center;
    p {
      color: #f00;
      font-size: 30px;
      margin: 62px 0;
    }
    button {
      width: 150px;
      height: 54px;
      background: #ff5640;
      color: #fff;
      cursor: pointer;
      border: 0;
      border-radius: 8px;
      font-size: 18px;
    }
  }
}







.home-bottle{
    margin: 20px 0 0 15px;
    width:60px;
    height:188px;
    background: url(../assets/images/icon_bottle/icon_bottle.png) 0 0 no-repeat; 
    background-size:1889px 188px;
    background-position: 0 0;
  }
	
	.home-add-team{ 
		text-align: center;
		font-size: 17px; 
		width:100%; 
		height:93vh;
		display: table; 
		div{  
			display: table-cell;
			vertical-align: middle;
		}
		img{
			width:130px;
		}
		p{
			color:#fff;
			margin:20px 0 40px;
		}
		button{
			cursor: pointer;
			background: #40DC23;
			color:#fff;
			padding:4px 50px;
			border:0;
			border-radius: 6px;
		}
	}
	
	
	.off-line{ 
		color:#ccc!important;
	}
	.off-lines{
		color:#6D7A86!important;
	}
	.ant-collapse{
		border:0!important;
	}
	.gray{
		color:#F1F3F4!important;
	}
	.green{
		color:#3FDB23!important;
	}
	.yellow{
		color:#FFB900!important;
	}
	.red{
		color:#FD1717!important;
	}
	.fade-enter-active {
	  animation: bounce-in .4s;
	}
	.fade-leave-active {
	  animation: bounce-in .4s reverse;
	}
  @keyframes change {
    0% {-webkit-transform:rotate(0deg);} 
　　  50% {-webkit-transform:rotate(180deg);} 
　　  100% {-webkit-transform:rotate(360deg);}
  }
	@keyframes bounce-in {
	  0% {
	    transform: scale(.2);
	  }
	  /*80% {
	    transform: scale(1.1);
	  }*/
	  100% {
	    transform: scale(1);
	  }
	}
	.mask{
		width:100%;
		height:100%;
		position: fixed;
		left:0;top:0;
		background: #000;
		opacity: .4;
		z-index: 1;
	}
	.monit-box-data-right{
		ul:first-child{
			border-bottom: 1px solid #DBDBDB; 
			padding-bottom: 3px;
		}
		li{
			line-height: 48px;
		}
		img{
			width:36px;
			margin:0 4px;
		} 
			font-size: 26px; 
	}
	.monit-box-data{
		float: left;
		width:50%;
		position: relative;
	}
	.monit-box-data-left{
		img{
			margin: 20px 0 0 15px;
			width:60px;
		}
		span{
			position: absolute;
			left:90px;
			top:100px; 
			strong{
				font-size: 35px;
			}
		}
	}
	.monit-box-data-right{
		border-left:1px solid #DBDBDB;
		width:50%;
	}
	.team-boxs{
		z-index: 2;
		height:332px;
		width:560px;
		position: fixed;
		left:50%;
		top:50%;
		margin-left: -280px;
		margin-top: -166px;
		background: #fff;
		border-radius: 8px;
		h3{
			margin:0;
			border-radius: 8px 8px 0 0;
			background: #151E2D;
			color:#6D7A86;
			height:82px;
			position: relative;
			span{
				position: absolute;
				left:130px;
				top:15px;
			}
			img{
				width:80px;
				margin-left: 20px;
			}
			div{
				position: absolute;
				right:20px;
				top:5px;
				img{
					width:35px;
				}
			}
		}
	}
	.selected{
		border-bottom: 4px solid #3FDB24;
		color:#2C9918!important;
	} 
	.padtop{
		padding-top: 15px;
	}
	.left,.right{ 
		float:left;
		margin-top: -10px;
	}
	.left{
    width:56%;
		border-right:1px solid #999;
	}
  .right{
    width:44%;
  }
	#home-content .ant-collapse-content-box{
		padding:0!important;
		color:#fff!important;
		div{
			background: #576371;
			height:90px;
			padding:10px 0;
			border-bottom: 1px solid #999; 
		}
		ul{
			display: -webkit-flex;
	    display: flex;
	    -webkit-justify-content: space-between;
	    justify-content: space-between;
	    li{  
				text-align: center;
				width:100%;
				font-size: 12px; 
				img{
					width:34px;
					height:34px;
				}
			}
		}
		p{ 
			margin:0;
			padding:0;
			font-size: 12px;
			img{
				height: 20px;
    		margin-top: -5px;
			}
		}
	}
	.team-info{
		height: 80px;
    	overflow: hidden;
		position: relative;
		text-align: center;
		font{
			position: absolute; 
			height:15px;
      		line-height: 14px;
      		font-size: 6px;
			border-radius: 9px;
      		padding:0 3px;
			top:8px;
			left:8px;
			background: rgba(255,185,1,1);
		}
		span{
			float:left;
			width:22%;
			margin:0 4%;
			padding-top:11px;
		}
		span:first-child{
			padding-top:0;
			img{
				width:80px;
				height:80px;
			}
		}
		img{
			width:40px;
			height:40px;
		} 
		
	}
	 
	.home-group{
		border-bottom:1px solid #3FDB24;
		display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
		li{ 
			cursor: pointer;
			line-height:40px;
			text-align: center;
			width:100%;
			font-size: 18px;
		}
	} 
.home-head {
  font-size: 36px;
  color: #fff;
  height: 60px !important;
  background-color: #1f2730;
}
.home-head p {
  margin: -5px 0 0 15px;
  //border-left: 5px solid #3fdb23;
  padding: 0 0 0 15px;
}
.home-head p::before {
  font-size: 40px;
  content: "|";
  color: #3fdb23;
  font-weight: bold;
  margin-right: 15px;
}
.home-iframe {
  height: e("calc(100vh - 64px)");
  border-left: 1px solid #C0C0C0;
}
.home-iframe iframe{
	border: none;
}

 
#home-content.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow{
	right: 20px;
}
#home-content{
	background: #404751;
	color: #fff;
  max-height:92vh;
  overflow: auto;
}
#home-content.ant-collapse > .ant-collapse-item > .ant-collapse-header{
	color:#fff!important;
	padding:0!important; 
}

.rescue-btn{
  position: absolute;
  bottom: 60px;
  right: 80px;
  width: 80px; 
  height:80px;
  border:0;
  border-radius: 50%;
  background: #3FDB23;
  color:#fff;
  font-size: 24px;
  cursor: pointer;
}
.amap-sug-result{
	border:0!important;
}











/** 小屏幕  */
@media (max-width: 768px) {
	#maple-layout .maple-menu .maple-menu-item.maple-menu-item-xs{
	   height: 50px;
	}
	#maple-layout .maple-menu .maple-menu-item.maple-menu-item-xs img{
	   width: 40px;
	}
	.home-head img{
		right:-30px!important;
	}
	.Setup-head div:nth-child(2){
		width:25%!important;
	}
	.Setup-head div:nth-child(3){
		width:25%!important;
	}
	.home-body>div:first-child{
		width:44%!important;
	}
	.home-body>div:last-child{
		width:56%!important;
	}
	.rescue-body>div:first-child{
		width:44%!important;
	}
	.rescue-body>div:last-child{
		width:26%!important;
	}
	.rescue-body .rescue-right .rescue-right-hot div{
		width:99%;
	}
	.rescue-center-data-left{
		width:70%!important;
	}
	.rescue-center-data{
		height:275px!important;
	}
	.kh-img{
		right:137px!important;
	}
}

@media screen and (max-width: 1025px) and (min-width: 768px) {
    .rescue-center-data-left{
    	width:17%!important;
    	text-align: center!important;
    }
}
</style>
